import React, { memo, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { useTranslation } from "react-i18next";
import { useDownloadMaterials } from "hooks/api";
import { Permission } from "api";
import { useMenu, usePermissions } from "hooks";
import { useSelector } from "react-redux";
import { checkMaterialSpecContentAvailability } from "store/features/materialSpecs/specs";

interface MaterialSpecMenuProps {
    materialSpecId: number;
    permissions: Permission[];
}

const MaterialSpecMenu = ({ materialSpecId, permissions }: MaterialSpecMenuProps) => {
    const { t } = useTranslation();
    const isEveryMaterialEmpty = useSelector(checkMaterialSpecContentAvailability(materialSpecId));
    const { DOWNLOAD } = usePermissions(permissions);
    const { refetch } = useDownloadMaterials("MATERIAL_SPEC", materialSpecId);
    const { open, anchorEl, handleOpen, handleClose } = useMenu();

    const handleMaterialsDownload = useCallback(
        // eslint-disable-next-line
        async (e: any) => {
            handleClose(e);
            await refetch();
        },
        [refetch, handleClose]
    );

    if (!DOWNLOAD?.display || isEveryMaterialEmpty) {
        return null;
    }

    return (
        <>
            <IconButton disableRipple size="small" aria-haspopup="true" onClick={handleOpen}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}>
                <MenuItem disabled={DOWNLOAD.disabled} onClick={handleMaterialsDownload}>
                    {t("buttons.label.download")}
                </MenuItem>
            </Menu>
        </>
    );
};

export default memo(MaterialSpecMenu, (prevProps, nextProps) => prevProps.materialSpecId !== nextProps.materialSpecId);
